module.exports = __webpack_public_path__ + "static/media/social-icon-twitter-white.86a70ce9.svg";